import { render, staticRenderFns } from "./commonNoCollapseSettings.vue?vue&type=template&id=2e5ba8ac"
import script from "./commonNoCollapseSettings.vue?vue&type=script&lang=js"
export * from "./commonNoCollapseSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports